import React from 'react';
import { getUnrotatedWeekNumber, getWeekDayName } from '../../../../utils/drivers';

export const SpecificDriverShiftsView = ({ data, search }) => {
   const filteredData =
      data &&
      data.filter((item) => {
         const name = `${item.employee.user.first_name} ${item.employee.user.last_name} (${item.employee.user.username})`;
         return name.toLowerCase().includes(search.toLowerCase());
      });

   const getDriverResource = (driverObj) => {
      return driverObj && driverObj.resource ? driverObj.resource : null;
   };

   return (
      <React.Fragment>
         <div className="my-table">
            <table className="table">
               <thead className="text-black font-bold text-left">
                  <tr>
                     <th>Employee</th>
                     <th>Schedule</th>
                     <th>Rotation Position</th>
                     <th>Week</th>
                     <th>Week Day</th>
                     <th>Shift</th>
                  </tr>
               </thead>
               <tbody>
                  {filteredData.length > 0 ? (
                     filteredData.map((driverShift) => {
                        const driverResource = getDriverResource(driverShift.employee);
                        const driverCalendar =
                           driverResource && driverResource.calendar ? driverResource.calendar : null;

                        return (
                           <tr key={driverShift.id}>
                              <td style={{ verticalAlign: 'middle' }}>
                                 {`${driverShift.employee.user.first_name} ${driverShift.employee.user.last_name} (${driverShift.employee.user.username})`}
                              </td>
                              <td style={{ verticalAlign: 'middle' }}>
                                 {driverResource && driverResource.calendar ? driverResource.calendar.name : 'N/A'}
                              </td>
                              <td style={{ verticalAlign: 'middle' }}>
                                 {driverResource && driverResource.rotation_position
                                    ? driverResource.rotation_position + 1
                                    : 1}
                              </td>
                              <td style={{ verticalAlign: 'middle' }}>
                                 {getUnrotatedWeekNumber(
                                    driverShift.week_type,
                                    driverResource && driverResource.rotation_position,
                                    driverCalendar && driverCalendar.rotation_weeks
                                 ) + 1}
                              </td>
                              <td style={{ verticalAlign: 'middle' }}>{getWeekDayName(driverShift.dayofweek)}</td>
                              <td>
                                 <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                                    <div
                                       style={{
                                          backgroundColor: driverShift.shift[0].color,
                                          padding: 5,
                                          color: 'white',
                                          borderRadius: 3,
                                          fontSize: 12,
                                       }}
                                    >
                                       {driverShift.shift[0].name}
                                    </div>
                                 </div>
                              </td>
                           </tr>
                        );
                     })
                  ) : (
                     <tr>
                        <td colSpan="6" className="text-center align-middle">
                           <div>No Data</div>
                        </td>
                     </tr>
                  )}
               </tbody>
            </table>
         </div>
      </React.Fragment>
   );
};
